export default class Tickets {
  constructor(api) {
    this.api = api;
  }

  getTickets(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/third-party-apis/youtrack/issues")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getTicketByID(ticketID, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/third-party-apis/youtrack/issues/" + ticketID)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  createTicket(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/third-party-apis/youtrack/issues", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getTicketComments(ticketID, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/third-party-apis/youtrack/comments/" + ticketID)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  createComment(data, ticketID, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/third-party-apis/youtrack/comments/" + ticketID, data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getCommentByID(commentID, ticketID, onSuccess, onError) {
    return this.api.http_fibercloud
      .get(
        "v1/third-party-apis/youtrack/issues/" +
          ticketID +
          "/comment/" +
          commentID
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  deleteTicket(id, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/third-party-apis/youtrack/issues/" + id)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  editTicket(data, ticketID, onSuccess, onError) {
    return this.api.http_fibercloud
      .put("v1/third-party-apis/youtrack/issues/" + ticketID, data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  deleteComment(commentID, ticketID, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete(
        "v1/third-party-apis/youtrack/issues/" +
          ticketID +
          "/comment/" +
          commentID
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  editComment(data, ticketID, commentID, onSuccess, onError) {
    return this.api.http_fibercloud
      .put(
        "v1/third-party-apis/youtrack/issues/" +
          ticketID +
          "/comment/" +
          commentID,
        { text: data }
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  createTicketAttachment(data, ticketID, onSuccess, onError) {
    return this.api.http_fibercloud
      .post(
        "v1/third-party-apis/youtrack/issues/" + ticketID + "/attachments",
        data
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  createCommentAttachment(data, ticketID, commentID, onSuccess, onError) {
    return this.api.http_fibercloud
      .post(
        "v1/third-party-apis/youtrack/issues/" +
          ticketID +
          "/comment/" +
          commentID +
          "/attachments",
        data
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  deleteTicketAttachment(ticketID, attachmentID, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete(
        "v1/third-party-apis/youtrack/issues/" +
          ticketID +
          "/attachments/" +
          attachmentID
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  deleteCommentAttachment(
    ticketID,
    commentID,
    attachmentID,
    onSuccess,
    onError
  ) {
    return this.api.http_fibercloud
      .delete(
        "v1/third-party-apis/youtrack/issues/" +
          ticketID +
          "/comment/" +
          commentID +
          "/attachments/" +
          attachmentID
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/tickets.js